var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgActionUpdateInfo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.387,
    height: 18.387,
    viewBox: "0 0 18.387 18.387",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9611",
    "data-name": "Group 9611",
    transform: "translate(-10372.675 -7729.815)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13694",
    "data-name": "Path 13694",
    d: "M10389.387,7695.333h4.455a.5.5,0,0,1,.5.5v11.731a.5.5,0,0,1-.078.269l-2.277,3.579a.5.5,0,0,1-.422.231h0a.5.5,0,0,1-.422-.24l-2.178-3.579a.5.5,0,0,1-.073-.26v-11.731A.5.5,0,0,1,10389.387,7695.333Zm3.955,1h-3.455v11.091l1.688,2.773,1.768-2.778Z",
    transform: "translate(8479.578 -5055.163) rotate(45)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13695",
    "data-name": "Path 13695",
    d: "M1-.5H3.455A1.5,1.5,0,0,1,4.955,1V4.044H-.5V1A1.5,1.5,0,0,1,1-.5ZM3.955,3.044V1a.5.5,0,0,0-.5-.5H1A.5.5,0,0,0,.5,1V3.044Z",
    transform: "translate(10386.705 7730.522) rotate(45)",
    fill: "#4d4d4d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_13693",
    "data-name": "Path 13693",
    d: "M60.519,16.021H76.3",
    transform: "translate(10314.259 7731.681)",
    fill: "none",
    stroke: "#4d4d4d",
    strokeLinecap: "round",
    strokeWidth: 1
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgActionUpdateInfo);
export default __webpack_public_path__ + "static/media/action_update_info.a0adfdf896da45c60aa1c149bdd0793f.svg";
export { ForwardRef as ReactComponent };